export default {
  getOrderInfo(state) {
    return state.orderInfo;
  },

  getClassInfo(state) {
    return state.classInfo;
  }
};
